import { Button, Container, FormControl, TextField, Typography } from "@material-ui/core";
import { unarchiveBidder } from "../../services/BidderService";
import * as React from "react";
import { ContainerStyles } from "../auction-management/styles/ContainerStyles";
import { Route } from "react-router";
import { useSnackbar } from "notistack";
import { FullWidthFeedback } from "../../models/full-width-feedback.model";

type UnarchiveBidderProps = {
    queueFeedback: (next: FullWidthFeedback) => void;
}

export const UnarchiveBidderContainer: React.FC<UnarchiveBidderProps> = ({ queueFeedback }: UnarchiveBidderProps) => {
    const classes = ContainerStyles();
    const { enqueueSnackbar } = useSnackbar();

    const [email, setEmail] = React.useState("");

    const unarchive = async (email: string) => {
        if (!email || email.length === 0) {
            enqueueSnackbar("Please enter the email of a bidder to be unarchived.", { variant: "warning" })
            return;
        }

        const result = await unarchiveBidder(email.trim());

        if (result.parsedBody) {
            queueFeedback(result.parsedBody);
        }

        setEmail('');
    }

    return (
        <>
            <Container maxWidth={"xl"} fixed style={{ padding: 0 }}>
                <FormControl className={classes.width100} variant="outlined" margin="dense" style={{ marginBottom: 24 }}>
                <TextField
                    className={classes.searchTextField}
                    margin="dense"
                    id="email"
                    placeholder={"Email"}
                    variant="outlined"
                    fullWidth
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                />
                </FormControl>

                <Container maxWidth={"xl"} fixed style={{ padding: 0, display: 'flex', justifyContent: 'flex-end', gap: '2rem' }}>
                    <Route
                        render={({ history }) => (
                        <Button
                            onClick={() => {
                            history.push(`/`);
                            }}
                        >
                            <Typography variant="subtitle1" gutterBottom>
                            Cancel
                            </Typography>
                        </Button>
                        )}
                    />

                    <Button onClick={(_) => unarchive(email)} variant="contained" color="primary">Confirm</Button>
                </Container>
            </Container>
        </>
    );
};
